import { API_ENDPOINT } from 'src/config/env.config';
import { baseApi } from './axios';
import { GetVideoResumeTemplateByIdAPIResponse } from 'types';

const baseUrl = `${API_ENDPOINT}/video-resume-template`;

export const getVideoResumeTemplateByRole = async (role: string): Promise<GetVideoResumeTemplateByIdAPIResponse> => {
	const response = await baseApi.get(`${baseUrl}/by-role/${role}`);
	return response.data;
};
